import Work1 from "../../assets/work1.png";
import Work2 from "../../assets/work2.png";
import Work3 from "../../assets/work3.png";
import Work4 from "../../assets/work4.png";
import Work5 from "../../assets/work5.png";
import Work6 from "../../assets/work6.png";
import Work7 from "../../assets/work7.png";

export const projectsData = [
    {
        id: 7,
        image: Work7,
        title: "Smoll URL",
        category: "web",
        link: "https://github.com/SShindow/smoll-url",
    },
    {
        id: 1,
        image: Work1,
        title: "Shopee Clone",
        category: "web",
        link: "https://shopee-clone-practice.vercel.app/",
    },
    {
        id: 2,
        image: Work2,
        title: "MÜSS",
        category: "app",
        link: "https://github.com/SShindow/muess",
    },
    {
        id: 3,
        image: Work3,
        title: "MÜSS Design",
        category: "design",
        link:"https://www.figma.com/file/Dfpc6OR9BoYHdLbZE7Ho4x/M%C3%9CSS?type=design&node-id=0%3A1&mode=design&t=VfbyazYAR6w8DpqQ-1",
    },
    {
        id: 4,
        image: Work4,
        title: "MediMe",
        category: "app",
        link: "https://medime.vercel.app",
    },
    {
        id: 5,
        image: Work5,
        title: "MediMe Design",
        category: "design",
        link: "https://www.figma.com/file/yu15ACxtHGT4yMeLzLJJGW/MediMe?type=design&node-id=0%3A1&mode=design&t=VfbyazYAR6w8DpqQ-1",
    },

    {
        id: 6,
        image: Work6,
        title: "EHealth",
        category: "app",
        link:"https://github.com/SShindow/eHeath",
    },

];

export const categoriesData = [
    {
        name: 'all',
    },

    {
        name: 'app',
    },

    {
        name: 'web',
    },

    {
        name: 'design',
    }
];